import { render, staticRenderFns } from "./stockTransfer.vue?vue&type=template&id=a87e1ec2"
import script from "./stockTransfer.vue?vue&type=script&lang=js"
export * from "./stockTransfer.vue?vue&type=script&lang=js"
import style0 from "./stockTransfer.vue?vue&type=style&index=0&id=a87e1ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports